var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4143 47.3693C57.4638 41.2261 61 34.8274 61 27.3765C61 12.2567 47.3457 0 30.4999 0C13.6544 0 0 12.2567 0 27.3769C0 42.4972 14.0962 52.8769 30.942 52.8769V57.8911C30.942 59.4798 32.5669 60.5022 33.9449 59.7454C38.2499 57.3804 46.2275 52.6367 51.4143 47.3693ZM15.6841 23.6847C18.0917 23.6847 20.0432 25.6489 20.0432 28.0684C20.0432 30.4926 18.0917 32.4567 15.6841 32.4567C13.2806 32.4567 11.3289 30.4926 11.3289 28.0684C11.3289 25.6489 13.2806 23.6847 15.6841 23.6847ZM34.8572 28.0684C34.8572 25.6489 32.9064 23.6847 30.5 23.6847C28.0939 23.6847 26.1429 25.6489 26.1429 28.0684C26.1431 30.4926 28.094 32.4567 30.5 32.4567C32.9064 32.4567 34.8572 30.4926 34.8572 28.0684ZM45.3153 23.6847C47.7225 23.6847 49.6712 25.6489 49.6712 28.0684C49.6712 30.4926 47.7226 32.4567 45.3153 32.4567C42.9082 32.4567 40.9568 30.4926 40.9569 28.0684C40.9569 25.6489 42.9083 23.6847 45.3153 23.6847Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.c0add9243a138dc43749810217ec7523.svg";
export { ForwardRef as ReactComponent };